import React, { lazy } from 'react';
import InstagramIcon from '@mui/icons-material/Instagram';
type Post = {
  src: string;
  alt: string;
};
const POSTS: Post[] = [{
  src: 'https://images.unsplash.com/photo-1551024601-bec78aea704b?auto=format&fit=crop&w=600&q=80',
  alt: 'Signature cocktail being garnished'
}, {
  src: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&w=600&q=80',
  alt: 'Crafted cocktails on a dark bar'
}, {
  src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?auto=format&fit=crop&w=600&q=80',
  alt: 'Plated gourmet small chops'
}, {
  src: 'https://images.unsplash.com/photo-1536935338788-846bb9981813?auto=format&fit=crop&w=600&q=80',
  alt: 'Colorful crafted cocktail'
}, {
  src: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?auto=format&fit=crop&w=600&q=80',
  alt: 'Private event venue at night'
}, {
  src: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&w=600&q=80',
  alt: 'Bartender pouring a drink'
}, {
  src: 'https://images.unsplash.com/photo-1502301197179-65228ab57f78?auto=format&fit=crop&w=600&q=80',
  alt: 'Assorted appetizers and finger food'
}, {
  src: 'https://images.unsplash.com/photo-1470337458703-46ad1756a187?auto=format&fit=crop&w=600&q=80',
  alt: 'Styled cocktails and small plates'
}];
export function InstagramFeed() {
  // Duplicate the list so the marquee can loop seamlessly.
  const loop = [...POSTS, ...POSTS];
  return <section aria-label="Instagram feed" className="w-full border-b border-gridline bg-canvas overflow-hidden" data-id="element-166">
      <div className="flex items-center justify-between px-6 md:px-10 py-5 border-b border-gridline" data-id="element-167">
        <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-3 text-white/80 hover:text-accent transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-168">
          <InstagramIcon fontSize="small" data-id="element-169" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold" data-id="element-170">
            @sipsandnibblez
          </span>
        </a>
        <span className="text-white/40 text-xs uppercase tracking-[0.3em] font-bold" data-id="element-171">
          Follow the Feed
        </span>
      </div>

      <div className="group relative" data-id="element-172">
        <div className="flex w-max animate-[ig-marquee_40s_linear_infinite] group-hover:[animation-play-state:paused]" data-id="element-173">
          {loop.map((post, i) => <a key={i} href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="relative block h-44 w-44 md:h-60 md:w-60 shrink-0 overflow-hidden border-r border-gridline focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-inset" aria-label={`View on Instagram: ${post.alt}`} data-id="element-174">
              <img src={post.src} alt={post.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 hover:scale-105" data-id="element-175" />
            </a>)}
        </div>
      </div>
    </section>;
}